/* ============================================================
   LOOMI & GLO — brandmark

   Wraps the ampersand in the header wordmark so it can be gold.

   Only the "&" character is touched, and only inside the header's own
   heading element. The name is read from the DOM and re-inserted as text
   nodes plus one span — never as innerHTML — so whatever the store name is
   set to, it cannot inject markup.

   If this never runs, the wordmark still renders correctly in the serif.
   The gold ampersand is the only thing lost.
   ============================================================ */
(function () {
  'use strict';

  function paint() {
    var nodes = document.querySelectorAll('.header__heading-link .h2, .header__heading .h2');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.querySelector('.dl-amp')) return;

      var text = el.textContent;
      var i = text.indexOf('&');
      if (i === -1) return;

      var before = text.slice(0, i);
      var after = text.slice(i + 1);

      var amp = document.createElement('span');
      amp.className = 'dl-amp';
      amp.textContent = '&';

      el.textContent = '';
      if (before) el.appendChild(document.createTextNode(before));
      el.appendChild(amp);
      if (after) el.appendChild(document.createTextNode(after));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
})();
